module.exports = __webpack_public_path__ + "img/电力-全铜芯电缆.63fc58b2.jpg";